import {DomainStore} from 'shared/store';
import {endpoints, types} from 'main/tools';
import Employee from 'main/stores/employees/Employee';
import CheckInSummary from 'main/stores/performance/CheckInSummary';
import { makeAutoObservable } from 'mobx';

class ManagerCheckInState {
  checkInState;
  match;
  history;

  isFormDirty = false;

  constructor() {
    makeAutoObservable(this, {
      checkInState: false,
      history: false
    });
  }

  receiveProps({checkInState, match, history}) {
    this.checkInState = checkInState;
    this.match = match;
    this.history = history;
  }

  async load() {
    const store = new DomainStore();
    await store._compose([
      endpoints.EMPLOYEES.ALL,
      endpoints.PERFORMANCE.REVIEWEE_CHECKINS.with(this.match.params.employeeId),
    ]);

    this.checkInState.allCheckins = store._getAll(types.PERFORMANCE.CHECKIN).map(c => new CheckInSummary(c));
    this.checkInState.sortAllCheckins();
    this.checkInState.selectedReviewee = new Employee(store._getSingle(types.EMPLOYEE, {id: this.match.params.employeeId}));
    await this.checkInState.selectFirstCheckin();
  }

  updateReviewerNotes(e, checkin) {
    checkin.reviewerNotes = e.target.value;
    checkin.autosaver.autosave();
  }

  updateSharedReviewerNotes(e, checkin) {
    checkin.sharedReviewerNotes = e.target.value;
    checkin.autosaver.autosave();
  }

  onCheckInSelected = async (checkin) => {
    await this.checkInState.selectCheckIn(checkin);
  };

  onMarkCompleted = async () => {
    await this.checkInState.markComplete(this.match.params.employeeId);
    this.history.push(`/reviewees/${this.match.params.employeeId}`);
  };

  onMarkUncompleted = async () => {
    await this.checkInState.markUncomplete(this.match.params.employeeId);
    this.history.push(`/reviewees/${this.match.params.employeeId}`);
  };
}

export default ManagerCheckInState;
